module.exports = __webpack_public_path__ + "static/img/workChanceBg.54eefe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workChanceBg.jpg
// module id = heSH
// module chunks = 1